import { render, staticRenderFns } from "./UnitManagePage.vue?vue&type=template&id=4cb7b696&"
import script from "./UnitManagePage.vue?vue&type=script&lang=js&"
export * from "./UnitManagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports